import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiClient, { tokenManager } from "../utils/axiosConfig";


export const adminLogin = createAsyncThunk(
  "admin/adminlogin",
  async (adminData, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const res = await apiClient.post("Admains/login", adminData, {
        meta: { skipAuthRedirect: true },
      });
      const data = await res.data;
      
      // Store JWT token if received
      if (data.token) {
        tokenManager.setToken(data.token);
      }
      
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const adminSlice = createSlice({
  name: "admin",
  initialState: {
    isLoading: true,
    adminData: {},
    isAuthenticated: false,
    token: tokenManager.getToken(),
  },
  reducers: {
    logout: (state) => {
      state.adminData = {};
      state.isAuthenticated = false;
      state.token = null;
      tokenManager.removeToken();
    },
    setToken: (state, action) => {
      state.token = action.payload;
      state.isAuthenticated = true;
      tokenManager.setToken(action.payload);
    },
    clearAuth: (state) => {
      state.adminData = {};
      state.isAuthenticated = false;
      state.token = null;
      tokenManager.removeToken();
    },
  },
  extraReducers: {
    [adminLogin.pending]: (state, action) => {
      state.isLoading = true;
    },
    [adminLogin.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.adminData = action.payload;
      state.isAuthenticated = true;
      if (action.payload.token) {
        state.token = action.payload.token;
      }
    },
    [adminLogin.rejected]: (state, action) => {
      state.isLoading = false;
      state.isAuthenticated = false;
      state.token = null;
    },
  },
});

export const { logout, setToken, clearAuth } = adminSlice.actions;
export default adminSlice.reducer;
